module.exports = __webpack_public_path__ + "img/main-bg.e905911a.jpg";